"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SMALL = exports.toastKinds = void 0;

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var toastKinds = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info",
  LOCKED: "locked",
  VISUALLY_HIDDEN: "visually-hidden"
};
exports.toastKinds = toastKinds;
var SMALL = constants.size.SMALL;
exports.SMALL = SMALL;
//# sourceMappingURL=types.js.map